import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import SelectGroup from './select-group';
import AutoCompleteGroup from './autocomplete-group';
import _ from 'underscore';

class Component extends BaseComponent {
    constructor(props) {
        super(props);
        if (props.data.country.value && !props.data.state.value) {
            props.getStates({
                prefix: props.prefix,
                country_id: props.data.country.value,
            });

            if (props.data.state.value && !isNaN(props.data.state.value)) {
                this.props.getCities({
                    prefix: props.prefix,
                    state_id: props.data.state.value,
                    country_id: props.data.country.value,
                });
            }
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps != this.props) {
            return true;
        }

        return false;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data.country.value != this.props.data.country.value && this.props.data.country.value) {
            this.props.getStates({
                prefix: this.props.prefix,
                country_id: this.props.data.country.value,
            });
        }

        if (prevProps.data.state.value != this.props.data.state.value && this.props.data.state.value) {
            this.props.getCities({
                prefix: this.props.prefix,
                state_id: this.props.data.state.value,
                country_id: this.props.data.country.value,
            });
        }
    }

    render({ prefix, label, disabled, data }) {
        return (
            <location-group>
                <SelectGroup
                    name={`${prefix}_country`}
                    label={`${label} Country:`}
                    placeholder='SELECT COUNTRY'
                    options={this.props.location.countries}
                    onChange={this.changeCountry}
                    disabled={disabled}
                    value={data.country.value}
                    error={data.country.error}
                />
                {this.renderStateSelect()}
                {this.renderCityInput()}
            </location-group>
        );
    }

    renderStateSelect = () => {
        if (
            this.props.data.country.value
            &&
            this.props.location[`${this.props.prefix}_states`]
            &&
            Object.keys(this.props.location[`${this.props.prefix}_states`]).length
        ) {
            return (
                <SelectGroup
                    name={`${this.props.prefix}_state`}
                    label={`${this.props.label} State/Province:`}
                    placeholder='SELECT STATE/PROVINCE'
                    options={this.props.location[`${this.props.prefix}_states`]}
                    onChange={this.changeState}
                    disabled={this.props.disabled}
                    value={this.props.data.state.value}
                    error={this.props.data.state.error}
                    sortBy='alpha'
                />
            );
        }

        return null;
    }

    renderCityInput = () => {
        if (
            this.props.data.country.value
            &&
            this.props.location[`${this.props.prefix}_cities`]
            &&
            Object.keys(this.props.location[`${this.props.prefix}_cities`]).length
        ) {
            return (
                <AutoCompleteGroup
                    name={`${this.props.prefix}_city`}
                    label={`${this.props.label} City:`}
                    placeholder='ENTER CITY'
                    options={this.props.location[`${this.props.prefix}_cities`]}
                    disabled={this.props.disabled}
                    value={this.props.data.city_id.value}
                    text={this.props.data.city.value}
                    error={this.props.data.city.error}
                    onSelect={this.selectCity}
                />
            );
        }

        return null;
    }

    changeCountry = (e) => {
        const returnE = {
            type: 'change',
            target: {
                name: `${this.props.prefix}_location`,
                value: {
                    country: {
                        value: e.target.value,
                        error: false,
                    },
                    state: {
                        value: null,
                        error: false,
                    },
                    city: {
                        value: null,
                        error: false,
                    },
                    city_id: {
                        value: null,
                    },
                },
            },
        };

        this.props.locationUpdate({
            [`${this.props.prefix}_states`]: null,
            [`${this.props.prefix}_cities`]: null,
        });

        this.onChange(returnE);
    }

    changeState = (e) => {
        const returnE = {
            type: 'change',
            target: {
                name: `${this.props.prefix}_location`,
                value: {
                    country: {
                        value: this.props.data.country.value,
                        error: this.props.data.country.error,
                    },
                    state: {
                        value: e.target.value,
                        error: false,
                    },
                    city: {
                        value: null,
                        error: false,
                    },
                    city_id: {
                        value: null,
                    },
                },
            },
        };

        this.props.locationUpdate({
            [`${this.props.prefix}_cities`]: null,
        });

        this.onChange(returnE);
    }

    selectCity = (e) => {
        const returnE = {
            type: 'change',
            target: {
                name: `${this.props.prefix}_location`,
                value: {
                    country: {
                        value: this.props.data.country.value,
                        error: this.props.data.country.error,
                    },
                    state: {
                        value: this.props.data.state.value,
                        error: this.props.data.state.error,
                    },
                    city: {
                        value: e.target.text,
                        error: false,
                    },
                    city_id: {
                        value: e.target.value,
                    },
                },
            },
        };

        this.onChange(returnE);
    }

    onChange = _.debounce(this.props.onChange, 200);
}

const mapStateToProps = (state) => ({
    location: state.location,
});

const mapDispatchToProps = (dispatch) => ({
    getStates: (payload) => dispatch({ type: 'product:get-states', payload: payload }),
    getCities: (payload) => dispatch({ type: 'product:get-cities', payload: payload }),
    locationUpdate: (payload) => dispatch({ type: 'location:update', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);